export default __webpack_public_path__ + "static/media/calendar.534d2b0d.svg";